import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import {
  DISPATCH_REPRINTS_INITIAL_STATE,
  type DispatchReprintsStore,
} from './dispatchReprints/dispatchReprints.types';
import { createDispatchReprintsActions } from './dispatchReprints/dispatchReprints.actions';

export const useDispatchReprintsStore = create<DispatchReprintsStore>()(
  devtools(
    persist(
      (set, get) => ({
        ...DISPATCH_REPRINTS_INITIAL_STATE,
        ...createDispatchReprintsActions(set, get),
      }),
      {
        name: 'dispatch-reprints',
        partialize: (state) => ({ byTabId: state.byTabId }),
      },
    ),
    { name: 'DispatchReprints' },
  ),
);
